import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {registerLicense} from "@syncfusion/ej2-base";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {Upload} from "./Upload";
registerLicense('ORg4AjUWIQA/Gnt2V1hiQlRPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9gSXZSdUVnWH5adHRUQGE=');



const router = createBrowserRouter([
    {
        path: "/s1",
        element: <App file="s1.txt" />,
    },
    {
        path: "/s2",
        element: <App file="s2.txt" />,
    },
    {
        path: "/s3",
        element: <App file="s3.txt" />,
    },
    {
        path: "/s4",
        element: <App file="s4.txt" />,
    },
    {
        path: "/s5",
        element: <App file="s5.txt" />,
    },
    {
        path: "/s6",
        element: <App file="s6.txt" />,
    },
    {
        path: "/s7",
        element: <App file="s7.txt" />,
    },
    {
        path: "/s8",
        element: <App file="s8.txt" />,
    },
    {
        path: "/s9",
        element: <App file="s9.txt" />,
    },
    {
        path: "/upload",
        element: <Upload />,
    }
    // ]);
], {basename:'/assessitems/'});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

      <RouterProvider router={router} />

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
